Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-online-order');

    if ($wrappers.length < 1) return;

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var $detailsWrapper = $('.x-order-details-expandable.online-orders', $wrapper);

        $('[data-click="expanded-order"]', $wrapper).on('click', function (e) {
            var $expandBtn = $(this);

            if ($expandBtn.hasClass('expanded')) return;

            $detailsWrapper.get(0).init();
        });
    });

});
